module.exports = __webpack_public_path__ + "img/ethereum.7c199546.svg";